import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface GameItem {
  href: string;
  imgSrc: string;
  alt?: string;
  onClick?: () => void;
}

const games = [
  {
    type: "video",
    videoSrc: "/assets/W1.webm",
    poster: "/images/W1.jpg",
    href: "/cong-thuc",
  },
  {
    type: "video",
    videoSrc: "/assets/W2.webm",
    poster: "/images/W1.jpg",
    href: "/casino",
  },
  {
    type: "video",
    videoSrc: "/assets/W3.webm",
    poster: "/images/W1.jpg",
    href: "/#",
  },
  {
    type: "video",
    videoSrc: "/assets/W4.webm",
    poster: "/images/W1.jpg",
    href: "/#",
  },
];

const GameListV2: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative">
      <div className="relative flex flex-col justify-center items-center md:pt-40 px-3 py-20">
        <div className="md:w-full w-[65%] relative">
          {/* mobile btn-back */}
          <button
            className="md:hidden w-1/3 right-3 absolute my-3"
            onClick={() => navigate("/login")}
          >
            <img src="/assets/btn-back.png" alt="Quay lại" />
          </button>
          {/* Title */}
          <div className="flex flex-col justify-center items-center md:mt-0 mt-12">
            <img
              src="/assets/header-logo.png"
              alt="TOOL BACCARAT AI 2026"
              className="mb-4"
            />
            <img
              className="mb-2"
              src="/assets/bcr-f1.png"
              alt="CHÀO MỪNG ĐẾN VỚI TOOL BACCARAT V6E"
            />
            <img
              className="mb-6"
              src="/assets/home-title.png"
              alt="CÔNG NGHỆ TOOL UPDATE MỚI NHẤT TRÊN THỊ TRƯỜNG"
            />
            {/* Games Grid */}
            <div className="relative grid md:grid-cols-2 grid-cols-1 gap-6 place-items-center">
              {games.map((game, index) => {
                return (
                  <Link
                    key={game.videoSrc}
                    to={game.href}
                    className="cursor-pointer btn-hover w-full shadow-md shadow-slate-50"
                  >
                    <figure className="overflow-hidden rounded-xl shadow-md">
                      <video
                        src={game.videoSrc}
                        poster={game.poster}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-full h-auto object-cover"
                      />
                    </figure>
                  </Link>
                );
              })}
            </div>
          </div>
          {/* right btn mobile */}
          <div className="md:hidden absolute top-1/2 right-[-25%] w-[52px] h-[52px]">
            <div className="flex flex-col gap-9">
              <a
                rel="noopener noreferrer"
                href="https://www.facebook.com/profile.php?id=61550584611151"
                target="_blank"
              >
                <img src="/assets/facebook.png" alt="Facebook" />
              </a>
              <a
                href="https://t.me/CONGBINH2026"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/tele.png" alt="Telegram" />
              </a>
            </div>
          </div>
        </div>
        {/* rigth side */}
        <div className="absolute md:top-20 right-16">
          <div className="md:flex flex-col items-end gap-[70px] hidden md:mt-16">
            <button
              className="md:flex hidden items-center"
              onClick={() => navigate("/login")}
            >
              <img src="/assets/btn-back.png" alt="Quay lại" />
            </button>
            <div className="flex flex-col gap-[46px] md:mt-80 mt-0">
              <a
                rel="noopener noreferrer"
                href="https://www.facebook.com/profile.php?id=61550584611151"
                target="_blank"
              >
                <img src="/assets/facebook.png" alt="Facebook" />
              </a>
              <a
                href="https://t.me/CONGBINH2026"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/tele.png" alt="Telegram" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );
};

export default GameListV2;
